import templateUrl from './template.html';

import '../../assets/svg/Icons/32/link-gray.svg';

import './style.less';

export default class IntegrationParametersModal {
  modal;

  constructor($uibModal) {
    'ngInject';

    Object.assign(this, { $uibModal });
  }

  open = (integration) => {
    const self = this;

    this.modal = this.$uibModal.open({
      size: '620',
      controllerAs: 'ctrl',
      controller() {
        this.integration = integration;

        this.submit = async () => {
          if (this.form) {
            this.form.$setSubmitted();
            if (this.form.$invalid) {
              return;
            }
          }

          const payload = integration.parameters.reduce(
            (agg, el) => ((agg[el.name] = el.value), agg),
            {}
          );

          self.close(payload);
        };
      },
      templateUrl,
    });

    return this.modal.result;
  };

  close = (result) => this.modal && this.modal.close(result);
}
